import * as React from 'react';
import { useSelector } from 'react-redux';

import { HUB_EVENTS } from '~/main/namespace';
import { LoggerScope } from '~/main/utils/logger';
import Logger from '~/renderer/utils/logger';

import { Publish } from './types';
import { useLocalServer } from './use-local-server';
import { useSetupAbly } from './use-setup-ably';

const defaultPublish = () => {
  Logger({ scope: LoggerScope.APP }).error({ err: new Error('Message sent before socket ready') });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const relayToMain = (message: string, data: any) => {
  window.ipcRenderer.send(HUB_EVENTS.RELAY_PUBLISH, { message, data });
};

export const SocketContext = React.createContext<Publish>(defaultPublish);

export const useSocket = () => React.useContext(SocketContext);

export const useSetupSocket = (): Publish => {
  const ably = useSetupAbly();
  const isLocalServerConnected = useSelector(
    state => state.connection.localServerStatus === 'connected',
  );
  const localServer = useLocalServer();

  return isLocalServerConnected ? localServer : ably || defaultPublish;
};
